import script from "./DividenIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./DividenIncome.vue?vue&type=script&setup=true&lang=js"

import "./DividenIncome.vue?vue&type=style&index=0&id=c48947cc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c48947cc"]])

export default __exports__